<template>
  <div class="nx-signing-modal-complete">
    <h4>{{$t('SigningSucceeded')}}</h4>
   
  </div>
</template>

<script>
import { ECounterApi } from "@/api";
export default {
  props: {
    value: {},
  },
  data() {
    return {
      files: []
    };
  },
  async created() {
      //await ECounterApi.confirmSign(this.value.fileId);
      const { files } = this.value;
      this.files = files;
      this.$emit("signComplete");
      window.location.assign(process.env.VUE_APP_ESS_URL);
      //close modal and redirect
  }
  ,  i18n: {
    messages: {
      en: {
        SigningSucceeded: 'Signing succeeded',
        DownloadSignedDoc: 'You may click the folloing link to download the signed document',
        Download: 'Download'
      },
      zh_hk: {
        SigningSucceeded: '簽署成功',
        DownloadSignedDoc: '您可以點擊以下鏈接下載簽名文件',
        Download: '下載'
      },
      zh_cn: {
        SigningSucceeded: '签署成功',
        DownloadSignedDoc: '您可以点击以下链接下载签名文件',
        Download: '下载'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nx-signing-modal-complete {
  text-align: center;
}
</style>
